export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img11-55daddec2bf7f677cc9d8b7aeb71b903.jpg";